export default __webpack_public_path__ + "static/media/02.6e27f65c.jpg";